<template>
  <transition name="fade">
    <div class="preloader__wrap">
      <div v-if="show" class="preloader display-flex-center justify-content-center">
        <div class="lds-ripple"><div></div><div></div></div>
        <!-- <div class="logo">
          <img src="@/assets/images/logo-nxb.png" alt="Hành trang số" />
          <div class="box-hover"></div>
        </div> -->
        <!-- <div class="lds-facebook"><div></div><div></div><div></div></div> -->
      </div>
      <!-- elm for load all font -->
      <span class="font-sanpro font-sanpro-light font-sanpro-semibold font-sanpro-medium font-sanpro-bold"></span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Preloader',
  data () {
    return {
      show: true
    }
  },
  mounted(){
    if(Boolean(this.show)) this.showToggle()
  },
  methods: {
    showToggle(){
      setTimeout(() => {
        this.show = false
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .preloader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100%;
    height: 100%;
    background: #f1f1f1;
    z-index: 99999;
  }
  .logo {
    background-repeat: no-repeat;

    img {
      transform: scale(0.5);
      -webkit-transform: scale(0.5);
      -webkit-animation: scaleIn 2s linear infinite;
      -moz-animation: scaleIn 2s linear infinite;
      -ms-animation: scaleIn 2s linear infinite;
      -o-animation: scaleIn 2s linear infinite;
      animation: scaleIn 2s linear infinite;
    }
  }
  p {
    font: 600 1.5rem;
    margin-top: 1rem;
  }

  @keyframes scaleIn {
    from {
      transform: scale(1);
      -webkit-transform: scale(1);
    }
    to {
      transform: scale(1.3);
      -webkit-transform: scale(1.3);
    }
  }

  .lds-facebook {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-facebook div {
    display: inline-block;
    position: absolute;
    left: 8px;
    width: 16px;
    background: #fff;
    animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }
  .lds-facebook div:nth-child(1) {
    left: 8px;
    animation-delay: -0.24s;
  }
  .lds-facebook div:nth-child(2) {
    left: 32px;
    animation-delay: -0.12s;
  }
  .lds-facebook div:nth-child(3) {
    left: 56px;
    animation-delay: 0;
  }
  @keyframes lds-facebook {
    0% {
      top: 8px;
      height: 64px;
    }
    50%, 100% {
      top: 24px;
      height: 32px;
    }
  }

  .lds-ripple {
    display: inline-block;
    position: relative;
    width: 60px;
    height: 60px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid $primary_color;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
</style>
